export const productType: any = [
	{key: "all", label: "전체"},
	{key: "driving", label: "드라이빙"},
	{key: "riding", label: "라이딩"}
];
